import React from 'react';
import TemplateList from './ListTemplate';

export default function SectionProducts({ data, settings, embedded }) {
  const limit = settings.limit || 6;
  const catId = settings.category_id;
  let list = data.products || [];
  if (catId) {
    const cat = (data.categories || []).find(c => c.id === catId);
    list = cat ? cat.products : [];
  }
  list = list.slice(0, limit);
  if (!list.length) return null;
  return (
    <section className={embedded ? undefined : 'container'} style={embedded ? undefined : { padding: 'clamp(48px, 8vw, 88px) 20px' }}>
      <TemplateList kind="product" items={list} settings={settings} />
    </section>
  );
}
